import { Routes, Route } from "react-router-dom";

import { List } from "@/tasks/view/list";
import { Create } from "@/tasks/view/create";

const TasksRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/create" element={<Create />} />
    </Routes>
  );
};

export { TasksRoutes };
